import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  TimeSlotParamType,
  TimeSlotRequestParamType,
  TimeSlotDataType,
  TimeSlotHeaderType,
} from 'features/Enterprise/CapacityHandler/services/timeSlot'

import { SLICE_NAME, fetchTimeSlotList, updateTimeSlot } from './timeSlotThunk'

// eslint-disable-next-line no-shadow
export enum TimeSlotDialogStateEnum {
  CLOSED,
  OPEN,
}
interface TimeSlotStateInterface {
  isLoading: boolean
  timeSlotList: TimeSlotDataType[]
  query: TimeSlotParamType
  updateTimeSlotDialogState: TimeSlotDialogStateEnum
  selectedTimeSlot: TimeSlotDataType | null
  upsertFCFSDialogState: {
    isOpen: boolean
  }
  timeSlotHeader: TimeSlotHeaderType | null
}

const initialState: TimeSlotStateInterface = {
  isLoading: false,
  timeSlotList: [],
  query: {
    loadingDockId: null,
  },
  updateTimeSlotDialogState: TimeSlotDialogStateEnum.CLOSED,
  selectedTimeSlot: null,
  upsertFCFSDialogState: {
    isOpen: false,
  },
  timeSlotHeader: null,
}

const timeSlotSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,
    updateQuery: (state, { payload }: PayloadAction<TimeSlotRequestParamType>) => {
      state.query = {
        ...state.query,
        ...payload,
      }
    },
    setUpsertFCFSDialogState: (state, { payload }: PayloadAction<{ isOpen: boolean }>) => {
      state.upsertFCFSDialogState = payload
    },
    setTimeSlotDialogState: (state, { payload }: PayloadAction<TimeSlotDialogStateEnum>) => {
      state.updateTimeSlotDialogState = payload
    },
    setSelectedTimeSlot: (state, { payload }: PayloadAction<TimeSlotDataType | null>) => {
      state.selectedTimeSlot = payload
    },
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload
    },
    setTimeSlotHeader: (state, { payload }: PayloadAction<TimeSlotHeaderType>) => {
      state.timeSlotHeader = payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimeSlotList.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchTimeSlotList.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.timeSlotList = payload
      })
      .addCase(fetchTimeSlotList.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(updateTimeSlot.fulfilled, (state) => {
        state.updateTimeSlotDialogState = TimeSlotDialogStateEnum.CLOSED
      })
  },
})

export const {
  resetState,
  updateQuery,
  setTimeSlotDialogState,
  setSelectedTimeSlot,
  setLoading,
  setUpsertFCFSDialogState,
  setTimeSlotHeader,
} = timeSlotSlice.actions
export default timeSlotSlice.reducer
